import MyCourseVM from './my-course-vm';

export default {
  init(node) {
    const coursesData = JSON.parse(node.dataset.coursesData)
    const $carousel = $(node).find('.slick-initialized');

    if (!ko.dataFor(node))
      ko.applyBindingsWithValidation(
        new MyCourseVM(coursesData),
        node,
        Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
      );

    if ($carousel.length) {
      $carousel.slick('refresh');
    } else {
      Kadenze.Carousel.init($(node).find('.js-carousel'));
    }

    Kadenze.Share.init();
  }
};
